<!--
 * @Author: RYL
 * @Description: 封装项目下拉和添加项目自定义组件
 * @Date: 2020-10-12 09:19:02
 * @LastEditTime: 2022-03-08 15:49:36
-->

<template>
  <div>
    <el-form
      :inline="inline"
      :model="groupForm"
      :rules="rules"
      ref="groupForm"
      label-width="200px"
      label-position="right"
    >
      <el-form-item
        :label="$t('lang.FastAccess.levelGrouping')"
        prop="groupOne.groupId"
      >
        <el-select
          v-model="groupForm.groupOne"
          filterable
          clearable
          value-key="groupId"
          :placeholder="$t('lang.groupinglist.selector')"
          size="mini"
        >
          <el-option
            v-for="item in projectFirstList"
            :key="item.groupId"
            :label="item.groupName"
            :value="item"
          ></el-option>
        </el-select>
        <slot name="newProject"></slot>
      </el-form-item>
      <el-form-item :label="$t('lang.FastAccess.secondaryGrouping')">
        <el-select
          v-model="groupForm.groupTwo"
          filterable
          clearable
          value-key="groupId"
          :placeholder="$t('lang.groupinglist.selector')"
          size="mini"
        >
          <el-option
            v-for="item in projectSecondList"
            :key="item.groupId"
            :label="item.groupName"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { getFirstGroup, getSecondGroup } from "@/api/cloudMonitor/projectGroup";
export default {
  props: {
    inline: {
      type: Boolean,
      default: false,
    },
    deviceItem: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      groupForm: {
        groupOne: {}, // 一级分组绑定值
        groupTwo: {},
      },
      projectFirstList: [], // 一级分组下拉选项
      projectSecondList: [],
      // 表单验证规则
      rules: {
        "groupOne.groupId": [
          {
            required: true,
            message: this.$t('lang.groupinglist.message17'),
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  watch: {
    groupForm: {
      deep: true,
      handler: function() {
        if (this.groupForm.groupOne) {
          this.getSecondList();
        }
      },
    },
    deviceItem: {
      immediate: true,
      deep: true,
      handler() {
        if (this.deviceItem && this.deviceItem.groupId) {
          if (
            this.deviceItem.groupLevel == 1 ||
            this.deviceItem.groupLevel == 0
          ) {
            this.groupForm.groupOne = this.deviceItem;
          } else {
            this.groupForm.groupOne.groupId = this.deviceItem.groupPid;
            this.groupForm.groupTwo = this.deviceItem;
          }
        }
      },
    },
  },
  mounted() {
    this.getFirstList();
  },
  methods: {
    clearData() {
      this.groupForm = {
        groupOne: {}, // 一级分组绑定值
        groupTwo: {},
      };
    },
    // 获取一级列表
    getFirstList() {
      let params = {
        current: 1,
        size: 99999,
      };
      getFirstGroup(params)
        .then((res) => {
          if (res.data.code === 0) {
            let data = res.data.data;
            this.projectFirstList = data.records;
            this.total = data.total;
          }
        })
        .catch(() => {});
    },
    // 获取二级列表
    getSecondList() {
      getSecondGroup(this.groupForm.groupOne.groupId).then((res) => {
        if (res.data.code === 0) {
          this.projectSecondList = res.data.data;
        }
      });
    },
    // 表单验证
    checkForm() {
      let flag = false;
      this.$refs.groupForm.validate((valid) => {
        if (valid) {
          flag = true;
        } else {
          flag = false;
          return false;
        }
      });
      return flag;
    },
    // 获取表单数据
    getFormData() {
      return this.groupForm;
    },
  },
};
</script>
<style scoped>
.form-input {
  width: 4rem;
}
</style>
